
















































































































import {Component, Ref, Vue} from "vue-property-decorator";
import {ApplicationPaymentDto, AttachmentHostType, AuditFlowScope} from "@/api/appService";
import api from "@/api";
import ExportWord from "@/components/DownloadWord/index.vue";
import AuditButtons from "@/components/AuditButtons/index.vue";
import {AuditBodyDto} from "@/utils/customDto";
import AttachmentsView from "@/components/AttachmentsView/index.vue";

@Component({
  name: "ApplicationPaymentDetail",
  components:{
    ExportWord,
    AuditButtons,
    AttachmentsView
  },
  filters: {
    formatStatus(type: string, statusList: any[]) {
      let result = "";
      statusList.forEach(item => {
        if (item.value == type) {
          result = item.text
          return
        }
      })
      return result
    }
  }
})
export default class ApplicationPaymentDetail extends Vue {
  @Ref() auditButtons!: AuditButtons;
  dataId?:number;
  detail: ApplicationPaymentDto = {};
  styles:string="";
  selector:string="table-detail-world";
  filename:string="用款申请详情";
  hostType = AttachmentHostType.ApplicationPayment;

  auditParams: AuditBodyDto = {
    hostId: undefined,
    hostType: undefined,
    auditFlowId: undefined,
    auditStatus: undefined,
    audit: undefined
  };

  created() {
    this.dataId = Number(this.$route.params.id)
    if (this.$route.params.id) {
      this.fetchDetail();
    }
  }

  // 获取详情
  async fetchDetail() {
    api.applicationPayment.get({ id: Number(this.$route.params.id) }).then(res => {
      this.detail = { ...res };
      this.auditParams!.hostId = res.id + "";
      this.auditParams!.auditFlowId = res.auditFlowId;
      this.auditParams!.auditStatus = res.auditStatus;
      this.auditParams!.audit = res.audit;
      if (res.auditFlowId) {
        (this.auditButtons as any).fetchCanAudit();
      }
      if (this.detail.auditFlowScope) {
        const auditFlowScope = this.detail.auditFlowScope
        this.auditParams.hostType = AuditFlowScope[auditFlowScope]
      }
    });
  }

  fetchAuditData() {
    return api.applicationPayment.audit;
  }

  changeAudit() {
    this.fetchDetail();
  }

  // 返回
  private cancel() {
    this.$router.back();
  }
}
